import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 12 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-40px" }}
    transition={{ duration: 0.45, delay, ease: "easeOut" }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children }) => (
  <span className="inline-flex items-center gap-2.5 text-[11px] font-bold uppercase tracking-[0.25em] text-silver">
    <span className="h-1.5 w-1.5 rounded-full bg-whatsapp" />
    {children}
  </span>
);
